import { render, staticRenderFns } from "./story_banner.vue?vue&type=template&id=53bdce44&"
import script from "./story_banner.vue?vue&type=script&lang=js&"
export * from "./story_banner.vue?vue&type=script&lang=js&"
import style0 from "./story_banner.vue?vue&type=style&index=0&id=53bdce44&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports